import { addAlpha } from "./components/Utils";
import JonathanSharpe from '../src/images/jonathanSharpe.jpg'
import AndrewGibbs from '../src/images/andrewGibbs.jpg'
import HamishEdsell from '../src/images/hamishEdsell.jpg'
import BenShearn from '../src/images/benShearn.jpg'
import ClaireHolden from '../src/images/claire.jpg'
import PaulHale from '../src/images/paulHale.jpg'
import RichardColyer from '../src/images/richardColyer.jpg'
import TamsinQuayle from '../src/images/tamsinQuayle.jpg'
import AlexRoca from '../src/images/alexRoca.jpg'
import EmmaPendlebury from '../src/images/emmaPendlebury.jpg'
import ConorDoran from '../src/images/conorDoran.jpg'
import PeterMorris from '../src/images/peterMorris.jpg'
import WilliamLough from '../src/images/williamLough.jpg'
import JakeThomson from '../src/images/jakeThomson.jpg'

export const bios = [
  {
    img: AndrewGibbs,
    title: 'CEO & Portfolio Manager',
    name: 'Andrew Gibbs',
    info: 'Andrew has over 30 years of investment experience in both hedge funds and long-only mutual funds. Andrew founded Otus Capital Management in October 2000 and for the four years to 01 December 2004 he was also Portfolio Manager for the Maga Fund. Formerly a director of M&G Investment Management, Andrew successfully ran the M&G European Smaller Companies Fund between 1998 and 2000. The Fund earned an AA rating from Standard & Poor’s Fund Research and the platinum medal from Lipper ARC. Prior to M&G, Andrew spent four years at a European hedge fund and four years at Lazard Brothers Asset Management. Andrew holds an MA (Hons) in Politics from Edinburgh University and is a member of the UK Society of Investment Professionals (formerly the IIMR).'
  },
  {
    img: HamishEdsell,
    title: 'Portfolio Manager',
    name: 'Hamish Edsell',
    info: 'Hamish Edsell joined the OCM team in September 2015. Prior to this, Hamish spent nine years at small and mid cap specialist brokers. Between 2011 and 2015 he helped establish the London office of Hauck & Aufhaeuser Privatbankiers, focusing on equity sales for the German market to UK and US investors. Before this Hamish worked for Helvea for one year and spent 4 years at Berenberg Bank in specialist sales for the European small/mid cap equities team. Hamish graduated from Edinburgh University in 2004 with a MA (Hons) in Arabic and Social Anthropology. He is a CFA Charterholder. '
  },
  {
    title: 'Portfolio Manager',
    name: 'Tamsin Quayle',
    info: "Tamsin Quayle joined OCM in December 2017 bringing with her 12 years of investment experience in European small cap equities. Tamsin took a family career break between 2009 and 2017. Prior to this she joined Ratio Asset Management when it was founded by Jonathan Sharpe in 2006 and worked there until 2009. Tamsin's career started at Gartmore in 1997 where she worked with Jonathan investing in European Small caps until 2005. Tamsin graduated in 1996 from Oxford University with an MA (Hons) in Geography. Tamsin is a CFA Charterholder.",
    img:TamsinQuayle
  },
  {
    title: 'Portfolio Manager',
    name: 'Jonathan Sharpe',
    info: 'Jonathan Sharpe is Portfolio Manager of the Maga Micro Cap Fund. Jonathan joined OCM in March 2013 as an experienced small cap equities manager and launched his own product, the Maga Micro Cap Fund, in November 2013. He came to us from Ratio Asset Management, which Jonathan founded in 2006, where he ran the Ratio European Fund, a European mid cap long/short fund with a peak AUM of $700m. Between 1997 and 2005 Jonathan headed the European Small Cap team at Gartmore and acted as lead investment manager on a range of funds including the European long/short Alphagen Cepheus Fund. Jonathan graduated from Oxford University in 1988 with an MA (Hons) in Engineering Science. He is a member of the CFA.',
    img:JonathanSharpe
  },
  {
    title: 'Portfolio Manager',
    name: 'William Lough',
    info: "William joined OCM in April 2026 as Portfolio Manager of the Otus Global Smaller Companies strategy. Prior to this, he was a Partner and Portfolio Manager at River Global Investors, which he joined in 2009. At River Global, William managed concentrated long-only global, international and UK strategies with a heavy skew to small and mid-cap companies, including five years as lead manager of the firm's Global Alpha strategy. William holds a First Class Honours degree in Modern History from the University of Oxford.",
    img:WilliamLough
  },
  {
    title: 'Portfolio Manager',
    name: 'Jake Thomson',
    info: "Jake joined OCM in April 2026 as Portfolio Manager of the Otus Global Smaller Companies strategy. He began his career as an analyst on MSIM's International Small Cap Fund in 2007, before moving to a European hedge fund as Senior Industrials Analyst. In 2017, he was a founding director of Velanne Asset Management, a Silchester-affiliated global value strategy, where he served as Senior Analyst. Most recently, Jake was a Head of Research at Ninety One. Across his career, he has operated primarily as a global generalist with a SMID cap bias. Jake holds an MA in Modern Languages from the University of Edinburgh and is a CFA Charterholder.",
    img:JakeThomson
  },
  {
    img:EmmaPendlebury,
    title: 'Head Of Business Development',
    name: 'Emma Pendlebury',
    info: 'Emma joined OCM in July 2021 as Head of Business Development. She is responsible for building and developing new and current investor relationships globally. Prior to this, Emma worked at GSA Capital Partners, where she held the position of Senior Marketing Associate and was involved in all aspects of marketing and investor relations across GSA’s investor base of institutional investors, Fund of Hedge Funds and family offices. Emma started her career in asset management by spending five years as a Marketing and Investor Relations Associate at Cantab Capital Partners. Emma graduated from the University of Cambridge in 2011 with an MA (Hons) in Law.'
  },
  {
    img:PaulHale,
    title: 'CFO',
    name: 'Paul Hale',
    info: "Paul is the firm's Chief Financial Officer ('CFO') and Chief Compliance Officer ('CCO'). Paul joined OCM at the company's inception in 2000 and oversees all financial and compliance aspects of the company and the funds. He joined OCM from the Royal Bank of Scotland Financial Markets, where he was the Financial Controller of the bank’s derivatives trading business. Prior to this, Paul worked for four years for Bank of Ireland Asset Management. Paul is a Chartered Accountant and a member of the UK Society of Investment Professionals (formerly IIMR). Paul graduated from University College Dublin with a Bachelor of Commerce degree in 1988."
  },
  {
    img:RichardColyer,
    title: 'COO',
    name: 'Richard Colyer',
    info: "Richard Colyer is the firm's Chief Operating Officer ('COO'). Richard joined Otus in January 2004 and is primarily responsible for managing the day to day running of Operations. Working closely with the CFO/CCO and the team he ensures that they remain efficient, streamlined and up to date with any regulatory and industry changes. Richard has previously worked at Greenwich Europe, Fleet National Bank and Harlow Butler Ueda. He completed his MSc in Information and Systems Management in 2009."
  },
  {
    img:BenShearn,
    title: 'Trader',
    name: 'Ben Shearn',
    info: 'Ben is our Head of Trading. Ben joined OCM in September 2013, working his way through the operations department to then work as the assistant trader before assuming primary responsibility in November 2016. Ben is responsible for all equity trading including algorithmic, electronic and voice orders. He covers multiple day order management across all venues including dark, lit and crossing networks. Ben manages the research provider review process and all broker allocation decisions. '
  },
  {
    img:AlexRoca,
    title: 'Head of Technology',
    name: 'Alex Roca',
    info: 'Alex joined OCM in January 2019 and currently serves as Head of Technology. He leads the strategic development of OCM’s technology platform, overseeing the architecture, implementation, and evolution of the firm’s bespoke Portfolio Management System, IOP, along with other mission-critical software initiatives. Since joining OCM, Alex has played a key role in shaping the firm’s technology roadmap, driving innovation, improving operational efficiency, and ensuring robust, scalable systems across the business. He also provides technical leadership across cross-functional projects and supports operational processes where needed. Prior to working at Otus, Alex was an Associate at a fintech research firm. He holds a BEng in Electrical & Electronic Engineering and Management and an MSc in Financial Mathematics and Computation.'
  },
  {
    img:ConorDoran,
    title: 'Operations Analyst',
    name: 'Conor Doran',
    info: 'Conor joined OCM in 2021 and has played an integral role in the firm’s operational development and growth. He is responsible for overseeing a broad range of operational functions, working closely with senior management and service providers to support the efficient delivery of investment operations, business processes, and strategic initiatives across the firm. Conor holds a BSc in Economics with Finance from Queen’s University Belfast. Before joining OCM, he gained experience with Mizuho and Citco Fund Services, providing him with a strong foundation in investment operations, fund administration, and financial services.'
  },
  {
    img:PeterMorris,
    title: 'Finance',
    name: 'Peter Morris',
    info: 'Peter’s first exposure to life at Otus came in the form of a summer internship in 2015 whilst studying for his undergraduate degree in History and Economics at Durham University. Since graduating in 2018, he spent a year at a two-man start-up in Munich, followed by three years with the Civil Service on the Finance Fast Stream. Returning to Otus in September 2022 he plays a key role in the firm’s financial operations, working closely with the CFO, and supports the firm’s compliance function. Peter is a Chartered Management Accountant and member of the Chartered Institute of Management Accountants (ACMA, CGMA).'
  },
  {
    img:ClaireHolden,
    title: 'Office Manager',
    name: 'Claire Holden',
    info: 'Claire joined OCM in March 2023 as Office Manager and is responsible for the day-to-day running of the office, ensuring that everything runs efficiently and effectively. Alongside this she assists with Client Services tasks and provides general administrative support to the team. Claire brings a wealth of experience to the role with over a decade of experience in office management across a variety of sectors.'
  },
];
export const MainFont = 'Montserrat,sans-serif,Arial'
export const COLOURS = {
  mainColor: '#8a9450',//'#585f34',
  indicatorColor: '#585f34',//'#585f34',
  fontColor: '#8a9450',
  tableHover: addAlpha('#8a9450', 0.8)
};
export const otusButtonStyleWhite = {
  color:'white',
  borderColor:'white',
':hover': {
  backgroundColor: 'rgba(255, 255, 255, .3)',
  borderColor:'white',
  color: 'white',
}
}
export const otusButtonStyleGreen = {
  color: COLOURS.fontColor,
  borderColor:COLOURS.fontColor,
':hover': {
  backgroundColor:addAlpha(COLOURS.mainColor, 0.3),
  borderColor:COLOURS.fontColor,
  color: COLOURS.fontColor,
}
}
export const inputStyle = {
  input: { color: 'white'},
  display:'flex',
  '& label.Mui-focused': {
    color: 'white',
  },
  '& label': {
    color: 'white',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'white',
      color:'white'
    },
    '&:hover fieldset': {
      borderColor: 'white',
      color:'white'
    },
    '&.Mui-focused fieldset': {
      borderColor: 'white',
      color:'white'
    },
  }
}
export const inputStyleColour = (colour) => {
  return {
  input: { color: colour},
  display:'flex',
  '& label.Mui-focused': {
    color: colour,
  },
  '& label': {
    color: colour,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: colour
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: colour,
      color:colour
    },
    '&:hover fieldset': {
      borderColor: colour,
      color:colour
    },
    '&.Mui-focused fieldset': {
      borderColor: colour,
      color:colour,
    },
  }
}
}